var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddressIconBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.999 1.49951C9.81178 1.50211 7.71487 2.37213 6.16826 3.91875C4.62165 5.46536 3.75162 7.56227 3.74902 9.74951C3.74902 16.8086 11.249 22.1406 11.5684 22.364C11.6947 22.4522 11.845 22.4995 11.999 22.4995C12.1531 22.4995 12.3034 22.4522 12.4297 22.364C12.749 22.1406 20.249 16.8086 20.249 9.74951C20.2464 7.56227 19.3764 5.46536 17.8298 3.91875C16.2832 2.37213 14.1863 1.50211 11.999 1.49951ZM11.9996 6.74978C12.5929 6.74978 13.1729 6.92573 13.6663 7.25537C14.1596 7.58502 14.5441 8.05355 14.7712 8.60173C14.9983 9.14991 15.0577 9.75311 14.9419 10.3351C14.8262 10.917 14.5405 11.4515 14.1209 11.8711C13.7013 12.2907 13.1668 12.5764 12.5848 12.6921C12.0029 12.8079 11.3997 12.7485 10.8515 12.5214C10.3033 12.2944 9.83481 11.9098 9.50516 11.4165C9.17552 10.9231 8.99957 10.3431 8.99957 9.74978C8.99956 9.35581 9.07715 8.9657 9.22791 8.60172C9.37867 8.23774 9.59965 7.90702 9.87823 7.62844C10.1568 7.34986 10.4875 7.12888 10.8515 6.97812C11.2155 6.82736 11.6056 6.74977 11.9996 6.74978Z",
    fill: "#135BA6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddressIconBlue);
export default __webpack_public_path__ + "static/media/addressIconBlue.d0d06cf0aee6a0872b84d29a4acfbc64.svg";
export { ForwardRef as ReactComponent };